import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import { getImgixImageData } from "@utils"

import HubspotForm from '@components/HubspotForm/HubspotForm'
import SEO from '@components/SEO/SEO'

import {
  FoundationsWebinarClassDIV,
  FoundationsWebinarClassesDIV,
  FoundationsWebinarClassesGridDIV,
  FoundationsWebinarDIV,
  FoundationsWebinarHERO,
  FoundationsWebinarHeroContentDIV,
  FoundationsWebinarHeroVideoDIV,
  FoundationsWebinarSignupContentDIV,
  FoundationsWebinarSignupDIV,
  FoundationsWebinarSignupImageDIV,
} from './index.styles'
import { graphql } from 'gatsby'

export const Head = () => (
  <SEO
    description="Learn the building blocks for reliable, high quality customer experiences, and how to put those pieces together, in this free six-part video course."
    image="/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--meta.png"
    permalink="/webinars/foundations-of-great-service/"
    title="Foundations of Great Service"
  />
)

const FoundationsWebinar = ({ data: { hubspotForm } }) => {
  return (
    <FoundationsWebinarDIV>
      <FoundationsWebinarHERO>
        <div className="container">
          <div className="grid">
            <div className="column column--2-12-S column--3-11-M column--1-6-L">
              <FoundationsWebinarHeroContentDIV>
                <h3 className="font-family--mono type--text-S">Skill-Building Course</h3>
                <h1 className="type--headline-medium--5XL">Foundations of<br /><span>Great Service</span></h1>
                <p className="type--text-L">Learn the building blocks for reliable, high quality customer experiences, and how to put those pieces together, in this free six-part course.</p>
                {hubspotForm && <HubspotForm {...hubspotForm} />}
                <p className="small type--text-XS">$99 value, yours free.</p>
              </FoundationsWebinarHeroContentDIV>
            </div>
            <div className="column column--2-12-S column--3-11-M column--7-13-L column--6-13-XL">
              <FoundationsWebinarHeroVideoDIV>
                <div>
                  <video
                    autoPlay
                    height="auto"
                    loop
                    muted
                    playsInline
                    poster="/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--hero--video-poster.png"
                    preload="auto"
                    width="100%"
                  >
                    <source src="/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--hero--patto.webm" type="video/webm" />
                    Your browser does not support the video tag.
                  </video>
                  <GatsbyImage
                    alt=""
                    className="bottom-left"
                    image={getImgixImageData(
                      '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--hero--abstract-bottom-left.png',
                      183,
                      1.6
                    )}
                  />
                  <GatsbyImage
                    alt=""
                    className="bottom-right"
                    image={getImgixImageData(
                      '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--hero--abstract-bottom-right.png',
                      576,
                      1.72
                    )}
                  />
                </div>
              </FoundationsWebinarHeroVideoDIV>
            </div>
          </div>
        </div>
      </FoundationsWebinarHERO>
      <div className="container">
        <FoundationsWebinarClassesDIV>
          <h2 className="type--headline-medium--4XL">What we’ll cover</h2>
          <FoundationsWebinarClassesGridDIV>
            <FoundationsWebinarClassDIV>
              <GatsbyImage
                alt=""
                image={getImgixImageData(
                  '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--Class1.png',
                  80,
                  1
                )}
              />
              <h3 className="font-family--mono type--text-S">Class 1</h3>
              <h6 className="type--headline-medium--XL font-weight--semibold">Discovering your customer service vision and values</h6>
              <p className="type--text-M">Explore the three essential elements for creating your specific customer service standard.</p>
            </FoundationsWebinarClassDIV>
            <FoundationsWebinarClassDIV>
              <GatsbyImage
                alt=""
                image={getImgixImageData(
                  '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--Class2.png',
                  80,
                  1
                )}
              />
              <h3 className="font-family--mono type--text-S">Class 2</h3>
              <h6 className="type--headline-medium--XL font-weight--semibold">Picking the right support tools</h6>
              <p className="type--text-M">A step-by-step guide to selecting and testing a customer service platform to help you deliver great service.</p>
            </FoundationsWebinarClassDIV>
            <FoundationsWebinarClassDIV>
              <GatsbyImage
                alt=""
                image={getImgixImageData(
                  '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--Class3.png',
                  80,
                  1
                )}
              />
              <h3 className="font-family--mono type--text-S">Class 3</h3>
              <h6 className="type--headline-medium--XL font-weight--semibold">Hiring the perfect customer service&nbsp;team</h6>
              <p className="type--text-M">Understand the skills and attitudes you’ll need and how to find and select the best candidates.</p>
            </FoundationsWebinarClassDIV>
            <FoundationsWebinarClassDIV>
              <GatsbyImage
                alt=""
                image={getImgixImageData(
                  '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--Class4.png',
                  80,
                  1
                )}
              />
              <h3 className="font-family--mono type--text-S">Class 4</h3>
              <h6 className="type--headline-medium--XL font-weight--semibold">Investing in self-service</h6>
              <p className="type--text-M">Why self-service matters, and how to build effective self-service options your customers will want to use.</p>
            </FoundationsWebinarClassDIV>
            <FoundationsWebinarClassDIV>
              <GatsbyImage
                alt=""
                image={getImgixImageData(
                  '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--Class5.png',
                  80,
                  1
                )}
              />
              <h3 className="font-family--mono type--text-S">Class 5</h3>
              <h6 className="type--headline-medium--XL font-weight--semibold">Measuring the right data</h6>
              <p className="type--text-M">Learn how to use reporting tools to better understand your customers, and your business.</p>
            </FoundationsWebinarClassDIV>
            <FoundationsWebinarClassDIV>
              <GatsbyImage
                alt=""
                image={getImgixImageData(
                  '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--Class6.png',
                  80,
                  1
                )}
              />
              <h3 className="font-family--mono type--text-S">Class 6</h3>
              <h6 className="type--headline-medium--XL font-weight--semibold">Building a customer-centric culture</h6>
              <p className="type--text-M">Looking beyond the customer service department to embed customer at the heart of your business.</p>
            </FoundationsWebinarClassDIV>
          </FoundationsWebinarClassesGridDIV>
        </FoundationsWebinarClassesDIV>
      </div>

      <FoundationsWebinarSignupDIV>
        <div className="container">
          <div className="grid">
            <div className="column column--1-7-M column--2-7-L">
              <FoundationsWebinarSignupContentDIV>
                <h2 className="type--headline-medium--3XL font-weight--semibold">Sign up for Foundations of Great Service</h2>
                {hubspotForm && <HubspotForm {...hubspotForm} />}
              </FoundationsWebinarSignupContentDIV>
            </div>
            <div className="column column--7-13-M">
              <FoundationsWebinarSignupImageDIV>
                <GatsbyImage
                  alt=""
                  image={getImgixImageData(
                    '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--signup-callout.png',
                    640,
                    1.51
                  )}
                />
              </FoundationsWebinarSignupImageDIV>
            </div>
          </div>
        </div>
      </FoundationsWebinarSignupDIV>
      <GatsbyImage
        alt=""
        className="rake rake-1"
        image={getImgixImageData(
          '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--rake-1.png',
          164,
          164 / 1247
        )}
      />
      <GatsbyImage
        alt=""
        className="rake rake-2"
        image={getImgixImageData(
          '/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--rake-2.png',
          107,
          107 / 495
        )}
      />
    </FoundationsWebinarDIV>
  )
}

export const query = graphql`
  query FoundationsWebinarQuery {
    hubspotForm(alternative_id: {eq: "20371c71-7a7c-42c3-8155-02db19678824"}) {
      ...HubspotFormFragment
    }
  }
`

export default FoundationsWebinar
